import AntonArabadjev from "../../../../images/content/introduction/applia-secretariat/AntonArabadjev.webp";
import GiuliaZilla from "../../../../images/content/introduction/applia-secretariat/GiuliaZilla.webp";
import MatteoRambaldi from "../../../../images/content/introduction/applia-secretariat/MatteoRambaldi.webp";
import MajPegelow from "../../../../images/content/introduction/applia-secretariat/MajPegelow.webp";

export const AppliaSecretariatMembersTeam5 = [
	{
		name: "Matteo Rambaldi",
		imageUrl: MatteoRambaldi,
		background: "pages.introduction.appliaSecretariat.members.matteoRambaldi.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.matteoRambaldi.functionTitle",
	},
	{
		name: "Giulia Zilla",
		imageUrl: GiuliaZilla,
		background: "pages.introduction.appliaSecretariat.members.giuliaZilla.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.giuliaZilla.functionTitle",
	},
	{
		name: "Anton Arabadjev",
		imageUrl: AntonArabadjev,
		background: "pages.introduction.appliaSecretariat.members.antonArabadjev.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.antonArabadjev.functionTitle",
	},
	{
		name: "Maj Pegelow",
		imageUrl: MajPegelow,
		background: "pages.introduction.appliaSecretariat.members.majPegelow.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.majPegelow.functionTitle",
	},
];
